import PropTypes from 'prop-types';
import { useFormContext, Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import Select from 'Components/Atoms/Select/Select';
import { cn } from 'Utils/cn';

export default function RHFTransactionTypeSelect({ name, className, ...other }) {
    const { control } = useFormContext();
    const { t } = useTranslation('providers');

    const options = [
        {
            value: 'income',
            label: t('manual-bank.income'),
        },
        {
            value: 'spending',
            label: t('manual-bank.expense'),
        },
    ];

    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState: { error } }) => (
                <Select
                    value={field.value[0]}
                    onChange={(value) => field.onChange([value])}
                    options={options}
                    error={error?.message}
                    className={cn('w-full', className)}
                    {...other}
                />
            )}
        />
    );
}

RHFTransactionTypeSelect.propTypes = {
    name: PropTypes.string,
    className: PropTypes.string,
};
